import { FiCheckCircle, FiXCircle, FiAlertTriangle, FiInfo, FiX } from 'react-icons/fi';
import useToastStore from '../../store/useToastStore';
import './Toast.css';

function Toast() {
  const { toasts, removeToast } = useToastStore();

  const getIcon = (type) => {
    switch (type) {
      case 'success':
        return <FiCheckCircle />;
      case 'error':
        return <FiXCircle />;
      case 'warning':
        return <FiAlertTriangle />;
      case 'info':
      default:
        return <FiInfo />;
    }
  };

  if (toasts.length === 0) return null;

  return (
    <div className="container-toast">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`item-toast type-${toast.type}-toast`}
        >
          <span className="icon-toast">{getIcon(toast.type)}</span>
          <span className="message-toast">{toast.message}</span>
          <button
            className="close-toast"
            onClick={() => removeToast(toast.id)}
            aria-label="Cerrar"
          >
            <FiX />
          </button>
        </div>
      ))}
    </div>
  );
}

export default Toast;
